import { Box, Space } from "arkh";
import React, { PropsWithChildren } from "react";
import { GroupItemLine } from "./GroupItemLine";

export function SectionSubItemContainer(
  props: PropsWithChildren<{
    color?: string | undefined | null;
    isLast?: boolean;
    spaceLeft?: Space;
  }>
) {
  return (
    <Box
      style={{
        flexDirection: "row",
        flex: 1,
      }}
      spaceLeft={props.spaceLeft}
      color="surface"
      cornerRadiusBottomLeft={props.isLast ? "large" : "none"}
      cornerRadiusBottomRight={props.isLast ? "large" : "none"}
    >
      <GroupItemLine
        color={props.color}
        paddingLeft={0}
        isLast={props.isLast}
      />
      <Box style={{ flex: 1, justifyContent: "center" }}>{props.children}</Box>
    </Box>
  );
}
